<template>
  <v-card>
    <v-toolbar style="background-color: #1daf80; color: #fff">
      <v-toolbar-title>
        <span class="headline">Requisitar óbito</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <div class="container pt-8">
        <div class="row">
          <div class="col-6">
            <v-select
              v-model="procedimentoSelected"
              label="Tipos óbito"
              :items="procedimentoList"
              item-text="text"
              item-value="value"
              hide-details
            ></v-select>
          </div>
          <div class="col-3">
            <v-text-field
              v-model="data_obito"
              label="Data de óbito"
              type="date"
              hide-details
              :min="DataHoje"
              class="mb-3"
            />
          </div>
          <div class="col-3">
            <v-text-field
              v-model="hora_obito"
              label="Hora de óbito"
              hide-details
              type="time"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <v-textarea v-model="obs_obito" label="Observação"></v-textarea>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-actions class="d-flex justify-content-between">
      <v-btn color="primary" outlined @click="$emit('close')"> Cancelar </v-btn>
      <v-btn
        color="#1daf80"
        @click="requisitarObito()"
        :dark="validForm()"
        :disabled="!validForm()"
      >
        Requisitar óbito
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Mixin from "@/mixins/vuex_snackbar_mixin.js";
import ObitoService from "@/services/obito_service.js";

export default {
  mixins: [Mixin],
  props: {
    petId: Object,
    tutorId: Object,
  },
  data() {
    return {
      services: {
        obitoService: ObitoService.build(),
      },
      unidadeId: 0,
      procedimentoList: [],
      procedimentoSelected: "",
      data_obito: new Date().toISOString().substr(0, 10),
      hora_obito: "",
      obs_obito: "",
      DataHoje: new Date().toISOString().substr(0, 10),
    };
  },
  watch: {},
  async beforeMount() {
    this.unidadeId = await JSON.parse(sessionStorage.getItem("vuex")).unidade
      .id;
  },
  async mounted() {
    this.unidadeId = await JSON.parse(sessionStorage.getItem("vuex")).unidade
      .id;
    this.getListProcedimentosObito();
  },
  methods: {
    getListProcedimentosObito() {
      this.services.obitoService
        .procedimentosObitoUnidade(this.unidadeId)
        .then(async (response) => {
          console.log("response", response);
          if (response.status !== 200) return;
          const { data } = await response.json();
          let list = [];
          for (let index = 0; index < data[0].length; index++) {
            const element = data[0][index];
            list.push({
              value: element.id,
              text: element.procedimento,
            });
          }
          this.procedimentoList = list;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          // this.loading = false;
        });
    },
    validForm() {
      return this.petId > 0 &&
        this.procedimentoSelected != "" &&
        this.data_obito != "" &&
        this.hora_obito != "" &&
        this.unidadeId > 0
        ? true
        : false;
    },
    model() {
      return {
        obito: 's',
        id_pet: this.petId,
        id_convenio_procedimento: this.procedimentoSelected,
        data_execucao: this.data_obito,
        hora_execucao: this.hora_obito,
        id_unidade: this.unidadeId,
        observacao: this.obs_obito,
      };
    },
    requisitarObito() {
      let model = this.model();
      this.services.obitoService
        .requisitarObito(model)
        .then(async (response) => {
          console.log("response", response);
          if (response.status !== 200){
            this.$_ACTIONS_showSnackbarMessage({
              message: "Data inválida!",
              color: "error",
            });
            return;
          }
          const { data } = await response.json();
          console.log("data", data);
          this.$emit("concluido");
          this.$_ACTIONS_showSnackbarMessage({
            message: "Óbito registrado com sucesso!",
            color: "sucess",
          });
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          // this.loading = false;
        });
    },
  },
};
</script>
<style></style>
